import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/bootstrap'
import SmoothScroll from './plugins/SmoothScroll'
import directiveScroll from './directives/directiveScroll'
import scrollactive from './plugins/scrollactive'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

Vue.config.productionTip = false

new Vue({
  router,
  store,  
  SmoothScroll,
  directiveScroll,
  scrollactive,
  render: h => h(App)
}).$mount('#app')
